









import { gql } from 'graphql-tag';
import { Component, mixins } from 'nuxt-property-decorator';

import { blockableBlockColorFragment, blockColorMixin } from '@/composables/block-color';

import { EmbeddedContentDataFragment } from '@/graphql/generated';
import { PageBlockMixin } from '@/modules/cms';

@Component({
  graphqlData: gql`
    fragment EmbeddedContentData on EmbeddedContentBlock {
      id
      content
      ...BlockColor
    }
    ${blockableBlockColorFragment}
  `,
})
export default class EmbeddedContentBlock extends mixins(PageBlockMixin<EmbeddedContentDataFragment>(), blockColorMixin) {
  mounted () {
    setTimeout(() => {
      const content = this.$refs.content as HTMLDivElement;
      const container = this.$refs.container as HTMLDivElement;

      // Script tags does not execute when using v-html, so we need to manually inject them
      // https://stackoverflow.com/a/71485628
      container.querySelectorAll('script').forEach((injectedScript) => {
        const script = document.createElement('script');
        Object.values(injectedScript.attributes).forEach((attribute) => {
          script.setAttribute(attribute.name, attribute.value);
        });

        script.remove();
        content.appendChild(script);
      });
    }, 0);
  }
}
